import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref, computed } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { useI18n } from "vue-i18n";
import DeviceModule from "@/store/modules/device";
import dayjs from "dayjs";
import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import { insertCashTransfer } from "@/utils/helpers/db";
import { LogService } from "@/services/logging";
import CashFloatModule from "@/store/modules/cash-float";
import randomstring from "randomstring";
import { signCashTransferTransaction } from "@/utils/helpers/fiskaly";
export default defineComponent({
  name: ModalComponents.CashInOut,
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var dialogFormVisible = ref(true);
    var modalVisible = dialogVisibleForStatus(ModalStatus.CashInOut);
    var isLoading = ref(false);
    var isCashIn = ref(true);
    var isCashOut = ref(false);
    var amount = ref(0.0);
    var locationId = ref(""); // const currencies = [
    //   { id: "CHF", label: "CHF" },
    //   { id: "EUR", label: "EUR" },
    // ];

    var groupCurrencies = computed(function () {
      // enable group currency only for cash in/out for now
      var groupCurrency = POSConfigModule.groupCurrencies.find(function (currency) {
        return currency.isDefault === 1;
      });

      if (groupCurrency) {
        return [groupCurrency];
      }

      return [POSConfigModule.groupCurrencies[0]];
    });
    var groupCurrency = computed(function () {
      var currency = groupCurrencies.value.find(function (c) {
        return c.isDefault === 1;
      }) || groupCurrencies.value[0];
      return currency;
    });
    var currency = ref(groupCurrency.value.label);
    var locationsList = computed(function () {
      return DeviceModule.locations.filter(function (l) {
        return l.id !== Number(hardwareLocationId.value);
      });
    });
    var hardwareLocationId = computed(function () {
      return DeviceModule.hardwareLocation ? DeviceModule.hardwareLocation.locationId : null;
    });
    var canConfirm = computed(function () {
      // user can confirm if
      // he entered amount greater than 0
      // he has at least one of "from" OR "to"
      var from = isCashOut.value ? hardwareLocationId.value : locationId.value;
      var to = isCashIn.value ? hardwareLocationId.value : locationId.value;
      return amount.value && from && to;
    });

    function cashInType() {
      isCashIn.value = true;
      isCashOut.value = false;
    }

    function cashOutType() {
      isCashIn.value = false;
      isCashOut.value = true;
    }

    function handleInputFocus(event) {
      if (event.target.value === "0") {
        event.target.value = "";
      }
    }

    function handleInputBlur(event) {
      if (event.target.value === "") {
        event.target.value = "0";
      }
    }

    return {
      t: t,
      modalVisible: modalVisible,
      dialogFormVisible: dialogFormVisible,
      cashInType: cashInType,
      cashOutType: cashOutType,
      isCashIn: isCashIn,
      isCashOut: isCashOut,
      amount: amount,
      currency: currency,
      groupCurrencies: groupCurrencies,
      locationsList: locationsList,
      locationId: locationId,
      isLoading: isLoading,
      canConfirm: canConfirm,
      hardwareLocationId: hardwareLocationId,
      handleInputFocus: handleInputFocus,
      handleInputBlur: handleInputBlur
    };
  },
  methods: {
    closeModal: function closeModal() {
      ModalModule.setStatus(ModalStatus.Hidden);
    },
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var groupId, cashTransferIn, transferAmount, amountInCents;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                groupId = POSConfigModule.groupId || UserModule.getUserGroupId; // Add a new CashTransfer of type (IN)

                cashTransferIn = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Number(_this.amount),
                  currency: _this.currency,
                  groupId: Number(groupId),
                  from: _this.isCashOut ? _this.hardwareLocationId : _this.locationId,
                  to: _this.isCashIn ? _this.hardwareLocationId : _this.locationId,
                  note: "",
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10)
                };
                LogService.info("Inserting cashTranser to indexedDB (attached)", {
                  params: cashTransferIn
                }); // lets update transferAmount in the state

                transferAmount = _this.isCashOut ? -1 * Number(_this.amount) : Number(_this.amount);
                CashFloatModule.updateTransfersAmount(transferAmount * 100); // lets update sum of cash in and cash out

                if (_this.isCashIn) {
                  CashFloatModule.updateSumOfCashIn(Number(_this.amount) * 100);
                }

                if (_this.isCashOut) {
                  CashFloatModule.updateSumOfCashOut(Number(_this.amount) * 100);
                } // lets now insert cashTransfer into db to be synched


                _context.next = 9;
                return insertCashTransfer(cashTransferIn);

              case 9:
                amountInCents = _this.isCashOut ? -1 * _this.amount : _this.amount;
                _context.next = 12;
                return signCashTransferTransaction(cashTransferIn.uuid, amountInCents);

              case 12:
                _this.closeModal();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});